import React, { useState, useEffect } from "react";
import styles from "./OnWinOrLossInAuto.module.css";
import { useSelector, useDispatch } from "react-redux";
import {
  changeIsOnWinReset,
  changeIsOnLossReset,
} from "../../redux/slices/gameSettingsSlice";
import clickAudio from "../../audios/click.mp3";
import getSoundEffectVolume from "../../utils/getSoundEffectVolume";
import useSound from "use-sound";
import {
  minPercentageOnWinOrLoss,
  maxPercentageOnWinOrLoss,
} from "../../config";
const OnWinOrLossInAuto = ({
  isChangeable,
  value,
  isOnWin,
  onChange,
  isResetProp,
}) => {
  const dispatch = useDispatch();
  const sounds = useSelector((state) => state.sounds);
  const [isReset, setIsReset] = useState(isResetProp);
  const [playClickSound] = useSound(clickAudio, {
    volume: getSoundEffectVolume(),
    soundEnabled: !sounds.isSoundEffectsMute,
  });
  const [tempValue, setTempValue] = useState(value);

  useEffect(() => {
    setIsReset(isResetProp);
  }, [isResetProp]);

  const clickSound = () => {
    playClickSound();
  };

  const handleBlur = () => {
    if (isChangeable) {
      const val = parseInt(tempValue);
      if (val >= minPercentageOnWinOrLoss && val < maxPercentageOnWinOrLoss) {
        onChange(val);
        if (isOnWin) {
          localStorage.setItem("onWinPercentage", val);
        } else {
          localStorage.setItem("onLossPercentage", val);
        }
      } else {
        onChange(0);
        setTempValue(0);
      }
    }
  };

  const handleIncreaseBy = () => {
    if (isChangeable) {
      clickSound();
      if (isOnWin) {
        dispatch(changeIsOnWinReset(false));
        localStorage.setItem("OnWinReset", false);
      } else {
        dispatch(changeIsOnLossReset(false));
        localStorage.setItem("OnLossReset", false);
      }
    }
  };
  const handleReset = () => {
    if (isChangeable) {
      clickSound();
      if (isOnWin) {
        dispatch(changeIsOnWinReset(true));
        localStorage.setItem("OnWinReset", true);
      } else {
        dispatch(changeIsOnLossReset(true));
        localStorage.setItem("OnLossReset", true);
      }
    }
  };
  if (!isOnWin) {
  }
  return (
    <div
      className={`${styles.controlGroup} ${
        isChangeable ? "" : styles.disableToClick
      }`}
    >
      <label className={styles.inputLabel}>
        {isOnWin ? "On Win" : "On Loss"}
      </label>
      <span className={styles.betContainer}>
        <span
          className={`${
            isReset ? styles.selectedBg : styles.withoutSelectedBg
          } ${styles.reset} ${
            isChangeable ? styles.ableToClick : styles.disableToClick
          } `}
          onClick={handleReset}
        >
          Reset
        </span>
        <span
          className={`${
            !isReset ? styles.selectedBg : styles.withoutSelectedBg
          } ${styles.increaseByButton} ${
            isChangeable ? styles.ableToClick : styles.disableToClick
          }  `}
          onClick={handleIncreaseBy}
        >
          Increase by:
        </span>{" "}
        <span
          className={`${styles.betInputWrapper} ${
            !isReset ? styles.selectedBgInput : styles.withoutSelectedBgInput
          }`}
        >
          <input
            type="number"
            style={{ position: "relative" }}
            className={styles.inputField}
            value={tempValue}
            step="any"
            min={minPercentageOnWinOrLoss}
            max={maxPercentageOnWinOrLoss}
            isChangeable={isChangeable && !isReset}
            onBlur={handleBlur}
            onChange={(e) => {
              if (isChangeable && !isReset) {
                clickSound();
                setTempValue(e.target.value);
              }
            }}
          />
          <span className={styles.percentage}>%</span>
        </span>
      </span>
    </div>
  );
};

export default OnWinOrLossInAuto;
